
import { Switch,Route,Redirect } from "react-router-dom";

import MainScreen from "../MainScreen/MainScreen";
import ProfileExplore from "../ProfileExplore/ProfileExplore";
import ConfirmRegistration from "../Registration/ApproveRegistration";
import Registration from "../Registration/Registration";
const routes = [
    {
        path: "/approved",
        exact:false,
        component: ConfirmRegistration
    },
    {
        path: "/",
        exact: true,
        component: Registration
    },
    {
        path: "/registration",
        exact: true,
        component: Registration
    },
  
    {
        path: "/user/:userId",
        exact: true,
        component: ProfileExplore
    },
   
   
]


const AllRoute = () => {
    return (
        <>
              <Switch>
       {
        routes.map((route,index)=>{
           return(
            <Route
            key={index}
            path={route.path}
            exact={route.exact}
            component={route.component}
          />
           )
         })
       }
      <Redirect to='/' /> 
     </Switch>
        </>
    )
}

export default AllRoute
